import { Row, Col, Card, Table, Button, Input, Tooltip, Switch } from "antd";
import React, { useState, useEffect, useRef } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import ShowTotal from "../../components/ShowTotal";
import ConfirmationBox from "../../components/ConfirmationBox";
import apiPath from "../../constants/apiPath";
import moment from 'moment';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import From from "./From";
import { getSortOrder } from "../../constants/conts";
import { PencilLineIcon, Trash2, FilterX, RefreshCcw } from "lucide-react";
import StateSelect from "../../components/select/StateSelect";
const Search = Input.Search;

function Index() {

  const sectionName = "City";
  const routeName = "city";

  const api = {
    status: apiPath.statusCity,
    addEdit: apiPath.addEditCity,
    list: apiPath.listCity,
    delete: apiPath.deleteCity,
    view: apiPath.viewCity
  }

  const [searchText, setSearchText] = useState('');
  const [stateId, setStateId] = useState(null);
  const { request } = useRequest()
  const [list, setList] = useState([])
  const { showConfirm } = ConfirmationBox()
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
  const [sortBy, setSortBy] = useState('');
  const lastFiltersRef = useRef({});
  const debouncedSearchText = useDebounce(searchText, 300);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();

  const columns = [
    {
      title: "En Name",
      dataIndex: "en_name",
      key: "en_name",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "en_name"),
      render: (_, { en_name }) => {
        return (
          en_name ? <span className="cap">{en_name}</span> : '-'
        );
      },
    },
    {
      title: "Hi Name",
      dataIndex: "hi_name",
      key: "hi_name",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "hi_name"),
      render: (_, { hi_name }) => {
        return (
          hi_name ? <span className="cap">{hi_name}</span> : '-'
        );
      },
    },
    {
      title: "Gj Name",
      dataIndex: "gj_name",
      key: "gj_name",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "gj_name"),
      render: (_, { gj_name }) => {
        return (
          gj_name ? <span className="cap">{gj_name}</span> : '-'
        );
      },
    },
    {
      title: "State Name",
      dataIndex: "state_name",
      key: "state_name",
      sorter: true,
      render: (_, { state }) => {
        return (
          state && state?.en_name ? <span className="cap">{state?.en_name}</span> : '-'
        );
      },
    },
    {
      title: "Status",
      key: "is_active",
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'Inactive',
          value: false,
        },
      ],
      render: (_, { is_active, _id }) => {
        return (
          <Switch
            checked={is_active}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            loading={loading}
            onChange={(checked) =>
              showConfirm({
                record: _id,
                path: api.status,
                // onLoading: () => setLoading(true),
                onSuccess: () => setRefresh((prev) => !prev),
                is_active: checked,
              })
            }
            className={is_active ? "custom-switch-checked" : "custom-switch-unchecked"}
          />
        );
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "created_at"),
      render: (_, { created_at }) => {
        return (
          moment(created_at).format('DD-MMM-YYYY')
        );
      },
    },
    {
      title: "Action",
      fixed: 'right',
      render: (_, record) => {
        return (
          <>
            <Tooltip title={"Update " + sectionName} color={"purple"} key={"update" + routeName}>
              <Button onClick={() => {
                setSelected(record)
                setVisible(true)
              }}>
                <PencilLineIcon size={15} />
              </Button>
            </Tooltip>
            <Tooltip title={"Delete " + sectionName} color={"red"} key={"delete" + routeName}>
              <Button
                danger
                className="ml-2"
                onClick={() => {
                  showConfirm({
                    record: record._id,
                    path: api.delete,
                    method: 'DELETE',
                    title: 'Delete City',
                    content: 'Are you sure you want to delete this city? This action cannot be undone.',
                    okButtonProps: { danger: true },
                    // onLoading: () => setLoading(true),
                    onSuccess: () => setRefresh((prev) => !prev),
                  })
                }}
              >
                <Trash2 size={15} />
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true)
    fetchData(pagination, lastFiltersRef.current, sortBy)
  }, [refresh, debouncedSearchText, sortBy, pagination.current, pagination.pageSize, stateId])

  const fetchData = (pagination, filters, sortValue = '') => {

    const filterActive = filters ? filters.is_active : null;

    request({
      url:
        api.list +
        `?status=${filterActive ? filterActive.join(',') : ''}` +
        `&page=${pagination.current}` +
        `&limit=${pagination.pageSize}` +
        `&search=${debouncedSearchText}` +
        `&sort=${sortValue || ''}` +
        (stateId ? `&state_id=${stateId}` : ''),
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination(prev => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data.data.list.totalDocs,
        }));
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  }

  const handleChange = (pag, filters, sorter) => {
    const { order, field } = sorter || {};

    let nextSort = '';
    if (order) {
      nextSort = `${field}:${order === 'ascend' ? 'asc' : 'desc'}`;
    }

    lastFiltersRef.current = filters || {};

    setSortBy(nextSort);

    setPagination(prev => ({
      ...prev,
      current: pag?.current || 1,
      pageSize: pag?.pageSize || prev.pageSize,
    }));
  };

  const onSearch = (e) => {
    setSearchText(e.target.value)
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  const hanldeRefresh = () => {
    setSearchText('');
    setStateId(null);
    setPagination({ current: 1, pageSize: 20 });
    setRefresh(prev => !prev);
    setSortBy("");
  };

  const clearFilters = () => {
    setStateId(null);
    setSearchText('');
    setPagination(prev => ({ ...prev, current: 1 }));
    setRefresh(prev => !prev);
  };

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              variant={false}
              className="criclebox tablespace mb-24"
              title={sectionName + " Management"}
              extra={
                <>
                  <Search
                    size="large"
                    onChange={onSearch}
                    value={searchText}
                    onPressEnter={onSearch}
                    placeholder="Search By English Name"
                    style={{ minWidth: 280 }}
                  />

                  <div className="flex justify-end w-100 gap-2">
                    {(stateId || searchText) && (
                      <Button
                        type="text"
                        onClick={clearFilters}
                        danger
                      >
                        <FilterX size={15} />
                        Clear Filters
                      </Button>
                    )}

                    <Button onClick={(e) => { setVisible(true); setSearchText(''); }}>Add New {sectionName}</Button>
                  </div>
                </>
              }
            >

              <Row gutter={[24, 0]} align="middle border-bottom pb-2">
                <Col xs={24} sm={12} md={8}>
                  <StateSelect
                    value={stateId}
                    onChange={(val) => {
                      setStateId(val);
                      setPagination(prev => ({ ...prev, current: 1 }));
                    }}
                  />
                </Col>
              </Row>

              <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>

              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    responsive: true,
                    defaultPageSize: 20,
                    pageSizeOptions: ['10', '20', '30', '50', '100']
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Add Modal */}
      {visible &&
        <From
          path={api.addEdit}
          sectionName={sectionName}
          show={visible}
          hide={() => { setSelected(); setVisible(false) }}
          data={selected}
          refresh={() => {
            setRefresh(prev => !prev)
          }}
        />
      }
    </>
  );
}

export default Index;
